var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"custom-card",class:_vm.customClass,style:(_vm.customStyle)},[_c('div',{staticClass:"container justify-content-center text-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }